import typographyStyles from './src/styles.module.css';

export {useTypography} from './src';
export {TypographySize} from './src/constants';
export type {Props as TypographyProp} from './src/types';

export {typographyStyles};
